export default {
  pagesHomeTitle: '你好',
  minUserInfo: {
    name1: '用户头像',
    name2: '用户账号',
    name3: '用户姓名',
    name4: '用户昵称',
    message1: '只能上传jpg/png/gif用户头像',
    message2: '用户信息更新成功'
  },
  topComponent: {
    message: '请输入搜索内容',
    tips: '真的要退出登录吗',
    tips1: '确定要清除缓存吗？',
    title1: '修改密码',
    title2: '旧密码',
    title3: '新密码',
    title4: '确认密码',
    title5: '个人中心',
    title6: '退出',
    title7: '清除缓存',
    error1: '请填写密码',
    error2: '请输入16~32位字母或数字组合',
    error3: '新密码和确认密码输入不一致',
    btn1: '关闭其他',
    btn2: '关闭所有',
    btn3: '更多'
  },
  navComponent: {
    title: '管理后台',
  }
}
